import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import MyInput from '../../../../templates/MyInput';
import MyButton from '../../../../templates/MyButton';
import Api from '../../../../Api';

function ActActionItem({
  action, actionsError, updateActions, index, actionsFocusOut, removeAction,
}) {
  const ref = useRef();
  const [selectedFilePreview, setSelectedFilePreview] = useState();

  const previewToShowOnButton = useMemo(() => selectedFilePreview || (action['picture-file'] ? Api.act_actions_img_url_no_request + action['act-action-id']
    : '/images/camera.png'), [selectedFilePreview, action]);

  useEffect(() => {
    if (!action.file) {
      setSelectedFilePreview(undefined);
      return;
    }

    setSelectedFilePreview(URL.createObjectURL(action.file));

    return () => URL.revokeObjectURL(action.file);
  }, [action.file]);

  return (
    <div className="row" key={index}>
      <MyInput
        name="text"
        error={actionsError}
        className="input_main"
        wrapperClassName="input_item default_size"
        value={action.text}
        onChange={updateActions(index)}
        onBlur={actionsFocusOut(index)}
      />
      <input
        ref={ref}
        name="file"
        hidden
        // wrapperClassName="input_item secondary"
        onChange={updateActions(index)}
        type="file"
        accept="image/png, image/gif, image/jpeg"
      />
      <MyButton
        onClick={() => {
          ref.current?.click();
        }}
        iconUri={previewToShowOnButton}
        className={`camera_button ${(action['picture-file'] || selectedFilePreview) && 'with_photo'}`}
        iconClassName="camera_button_image"
        disabled={!action.text}
      />

      {action.text && (
        <MyButton
          className="close_button"
          iconUri="/images/close.png"
          onClick={removeAction(index)}
        />
      )}
      {/* {!action.file && action['picture-file'] && (
        <img
          className="action_image"
          src={`${Api.url}/api/image/act/26d26ef8-4d7b-4706-b9ed-2bff1d50043a/${action['act-action-id']}`}
          alt=""
        />
      )} */}
    </div>
  );
}

export default ActActionItem;
